// RangePickerInput.js
import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";

const { RangePicker } = DatePicker;

const RangePickerInput = (props) => {
  const {
    value,
    onChange,
    name,
    style,
    suffixIcon,
    variant,
    separatorColor,
    disabled = false,
  } = props;

  const Dates = [
    dayjs.unix(value?.start_date, "DD MMM"),
    dayjs.unix(value?.end_date, "DD MMM"),
  ];

  const dateFormatter = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const startDate = dates[0].unix().toString();
      const endDate = dates[1].unix().toString();
      const formattedDates = { start_date: startDate, end_date: endDate };
      onChange(formattedDates, name);
    }
  };
  return (
    <div style={{ width: "165px" }}>
      {SC.GlobalStyles}
      <RangePicker
        name={name}
        format={"DD MMM"}
        value={Dates}
        onChange={dateFormatter}
        allowClear={false}
        variant={variant}
        disabled={disabled}
        suffixIcon={
          suffixIcon ? (
            suffixIcon
          ) : (
            <InnoIcons.CalendarMonthIcon
              style={{ color: "white", fontSize: "15px" }}
            />
          )
        }
        separator={
          separatorColor ? (
            <InnoIcons.RemoveIcon
              style={{
                color: separatorColor,
                fontSize: "15px",
              }}
            />
          ) : (
            <InnoIcons.RemoveIcon
              style={{ color: "white", fontSize: "15px" }}
            />
          )
        }
        style={style}
      />
    </div>
  );
};

export default RangePickerInput;
